<template>
	<div class="d-inline-block">
		<div class="bg-dark p-1 d-flex justify-content-around align-items-center" >
			<div class="border rounded-circle border-secondary bg-secondary aup-base-badge__svg">
			</div>
			<p class="m-0 text-white mx-2 text-capitalize t-bold">error:call:58</p>
		</div>
	</div>
</template>

<script>
    export default {
        name: "BaseBadge",
		props: {
        	name: {
				type: String,
				default: null,
			}
		},
    };
</script>

<style lang="scss">
.aup-base-badge {
	&__svg {
		height: 40px;
		width: 40px;
	}
}
</style>
